import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Select,
  Card,
  Space,
  Divider,
  Tabs
} from "antd";

const { Option } = Select;

export default function GoiThauBuilder() {
  const [form] = Form.useForm();
  const list = [
      {
          "id": 1,
          "title": "Bước 1",
          "fields": [
              {
                  "key": "ten_goi_thau",
                  "label": "Tên gói thầu",
                  "type": "text"
              }
          ]
      },
      {
          "id": 2,
          "title": "Bước 2",
          "fields": [
              {
                  "key": "test",
                  "label": "Test",
                  "type": "text"
              },
              {
                  "key": 'check_box_1',
                  "label": "Check box 1",
                  "type": "checkbox"
              }
          ]
      }
  ]
  const [steps, setSteps] = useState(list);
  console.log(steps)
  const addStep = () => {
    const nextId = steps.length + 1;

    setSteps([
      ...steps,
      {
        id: nextId,
        title: `Bước ${nextId}`,
        fields: [],
      },
    ]);
  };

  const addFieldToStep = (stepId, type) => {
    setSteps((prev) =>
      prev.map((step) => {
        if (step.id === stepId) {
          return {
            ...step,
            fields: [
              ...step.fields,
              {
                key: Date.now(),
                label: "Nhập label",
                type,
              },
            ],
          };
        }
        return step;
      })
    );
  };
  useEffect(() => {
    const defaultValues = {};

    list.forEach(step => {
      const stepKey = `step_${step.id}`;
      defaultValues[stepKey] = {};

      step.fields.forEach(field => {
        if (field.type === "text") {
          defaultValues[stepKey][`input_${field.key}`] = field.label;
        }

        if (field.type === "checkbox") {
          defaultValues[stepKey][`checkbox_${field.key}`] = {
            label: field.label,
            options: []
          };
        }
      });
    });

    form.setFieldsValue(defaultValues);
  }, []);
  // =========================
  // Render input theo type
  // =========================
  const renderInput = (field, stepId) => {
    const valueName = [`step_${stepId}`, `field_${field.key}`];
    console.log(field)
    // =========================
    // TEXT
    // =========================
    if (field.type === "text") {
    return (
      <>
        <Form.Item
          placeholder="Nhập label"
          label={field.label || "Text"}
          name={[`step_${stepId}`,`input_${field.key}`]}
        >
          <Input />
        </Form.Item>

        <Divider />
      </>
    );
    }

    // =========================
    // CHECKBOX
    // =========================
    if (field.type === "checkbox") {
    const baseName = [`step_${stepId}`, `checkbox_${field.key}`];

    return (
      <>
        {/* LABEL */}
        <Form.Item
          label={field.label || "Text"}
          name={[...baseName, "label"]}
        >
          <Input placeholder="Nhập label checkbox" />
        </Form.Item>

        {/* OPTIONS */}
        <Form.List name={[...baseName, "options"]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <Form.Item
                  {...restField}
                  key={key}
                  label={`Lựa chọn ${index + 1}`}
                  name={name}
                >
                  <Input
                    addonAfter={
                      <Button danger onClick={() => remove(name)}>
                        X
                      </Button>
                    }
                  />
                </Form.Item>
              ))}

              <Button type="dashed" onClick={() => add()}>
                + Thêm lựa chọn
              </Button>
            </>
          )}
        </Form.List>

        <Divider />
      </>
    );}
    return null;
  };
  // =========================
  // Submit
  // =========================
  const onFinish = (values) => {
  console.log("DATA:", values);

  const data = {
    id: "123",
    step: JSON.stringify(values),
  };

    localStorage.setItem("goiThauData", JSON.stringify(data));
  };

  return (
    <Card title="Tạo gói thầu động">
      <Button type="primary" onClick={addStep} style={{ marginBottom: 20 }}>
        + Thêm bước
      </Button>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Tabs type="card">
          {steps.map((step) => (
            <Tabs.TabPane tab={step.title} key={step.id}>
              <Card
                type="inner"
                title={
                  <Input
                    value={step.title}
                    onChange={(e) =>
                      setSteps((prev) =>
                        prev.map((s) =>
                          s.id === step.id
                            ? { ...s, title: e.target.value }
                            : s
                        )
                      )
                    }
                  />
                }
                style={{ marginBottom: 20 }}
              >
                {/* Chọn loại field */}
                <Space>
                  <Select
                    placeholder="Chọn loại input"
                    style={{ width: 200 }}
                    value={step.selectedType}
                    onChange={(value) => {
                      setSteps((prev) =>
                        prev.map((s) =>
                          s.id === step.id
                            ? { ...s, selectedType: value }
                            : s
                        )
                      );
                    }}
                  >
                    <Option value="text">Text</Option>
                    <Option value="checkbox">Checkbox</Option>
                  </Select>

                  <Button
                    type="primary"
                    onClick={() => {
                      if (!step.selectedType) return;

                      addFieldToStep(step.id, step.selectedType);

                      setSteps((prev) =>
                        prev.map((s) =>
                          s.id === step.id
                            ? { ...s, selectedType: undefined }
                            : s
                        )
                      );
                    }}
                  >
                    Thêm
                  </Button>
                </Space>

                <Divider />

                {step.fields.map((field) => (
                  <div key={field.key} style={{ marginBottom: 20 }}>
                    {renderInput(field, step.id)}
                  </div>
                ))}
              </Card>
            </Tabs.TabPane>
          ))}
        </Tabs>
        <Button type="primary" htmlType="submit">
          Lưu gói thầu
        </Button>
      </Form>
    </Card>
  );
}